import React, { useState } from 'react';
import { FilterViews } from '../constants';
import PanelFooter from '../../../searchAndFilter/components/panelFooter';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { styles } from '../utils';
import {
  usePerformSearch,
  useSearchDisplayFields,
  useSearchTargetRelations,
  useSelectedSearchTarget,
} from 'redux/hooks/searchnFilter';
import { useDispatch } from 'react-redux';
import {
  IFilterDTO,
  ISearchDisplayFieldDTO,
  SearchDisplayFieldStatus,
} from 'business/models/Models';
import {
  addDisplayFields,
  addSearchFilters,
  resetSearchFilters,
} from 'redux/reducers/searchnFilterReducer';
import FilterParametersPanel from './FilterParametersPanel';
import { bottomMenuAllowedRoutes } from 'components/searchAndFilter/constants';

export const FiltersButtonsContainer = () => {
  const [contentView, setContentViewState] = useState<FilterViews>(
    FilterViews.SELECTED_PARAMETERS,
  );
  const dispatch = useDispatch();
  const performSearch = usePerformSearch();
  const displayFields = useSearchDisplayFields();
  const targetRelations = useSearchTargetRelations();
  const searchTargetId = useSelectedSearchTarget();
  const [selectedFilters, setSelectedFilters] = useState<IFilterDTO[]>([]);
  const isCanvasRoute = bottomMenuAllowedRoutes.some((substring) =>
    window.location.pathname.includes(substring),
  );

  const onModify = () => {
    setContentViewState(FilterViews.PARAMETER_SELECTION);
  };
  const onReset = () => {
    dispatch(resetSearchFilters());
  };
  const onApply = () => {
    setContentViewState(FilterViews.SELECTED_PARAMETERS);
    performSearch();
  };

  const onApplyFilters = () => {
    if (selectedFilters.length) {
      const fields = [];
      selectedFilters.forEach((f, i) => {
        const searchField = targetRelations[searchTargetId];
        fields.push({
          displayOrder: displayFields.length + i + 1,
          searchFieldId: f.searchFieldId,
          status: SearchDisplayFieldStatus.Display,
          columnHeader: searchField
            .map((x) => x.searchFields.find((sf) => sf.id === f.searchFieldId))
            .find((sf) => sf !== undefined).fieldAndTableDisplayName,
        } as ISearchDisplayFieldDTO);
      });
      dispatch(addSearchFilters(selectedFilters));
      dispatch(addDisplayFields(fields));
      setSelectedFilters([]);
    }
    setContentViewState(FilterViews.SELECTED_PARAMETERS);
  };

  const handleApply = () => {
    if (contentView === FilterViews.PARAMETER_SELECTION) {
      onApplyFilters();
    }
    if (contentView === FilterViews.SELECTED_PARAMETERS) {
      onApply();
    }
  };

  const buttons: RMCustomButtonProps[] = [
    {
      title: 'ADD FILTER',
      onClick: onModify,
      contentContainerStyle: styles.modify,
      mainContainerClass: contentView === FilterViews.PARAMETER_SELECTION ? 'hidden' : '',
    },
    {
      title: 'RESET',
      onClick: onReset,
      isDisabled: false,
      contentContainerStyle: styles.reset,
      mainContainerClass: contentView === FilterViews.PARAMETER_SELECTION ? 'hidden' : '',
    },
    {
      title: 'APPLY',
      onClick: handleApply,
      contentContainerStyle: styles.applyEnabled,
      isDisabled: false,
    },
  ];

  return (
    <div id="filtersbuttonscontainer" className="flex flex-col h-full">
      <div
        id="filtersbuttonscontainer-filter-parameters-panel"
        className={isCanvasRoute ? 'h-[76%]' : 'h-[84%]'}
      >
        <FilterParametersPanel
          setContentViewState={setContentViewState}
          contentView={contentView}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      </div>
      <div
        id="filtersbuttonscontainer-panel-footer"
        className="h-[7%] flex items-center justify-end"
      >
        <PanelFooter buttons={buttons} />
      </div>
    </div>
  );
};

export default FiltersButtonsContainer;
